export default __webpack_public_path__ + "static/media/benhphu.c90c557f.png";